import React from 'react';

const gestaoIcon = ({ width = "800px", height = "800px", fill = "#000000",  className = "" ,onClick }) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 200 200"
    xmlns="http://www.w3.org/2000/svg"
    fill={fill}
    onClick={onClick} // Adiciona o evento onClick
    style={{ cursor: "pointer" }} // Adiciona o cursor de ponteiro
  >
    <title>Gestão Icone</title>
    <path d="M36.5,75C41,89.5,54,100,70,100s29-10.5,33.5-25H170a10,10,0,0,0,0-20H103.5C99,40.5,86,30,70,30S41,40.5,36.5,55H25a10,10,0,0,0,0,20ZM70,50A15,15,0,1,1,55,65,14.73,14.73,0,0,1,70,50Zm105,75H163.5C159,110.5,146,100,130,100s-29,10.5-33.5,25H30a10,10,0,0,0,0,20H96.5c4.5,14.5,17.5,25,33.5,25s29-10.5,33.5-25H175a10,10,0,0,0,0-20Zm-45,25a15,15,0,1,1,15-15A14.73,14.73,0,0,1,130,150Z" />
  </svg>
);

export default gestaoIcon;
